module.exports = __webpack_public_path__ + "static/logo-c47c604ae1dee866794d082e176e61c7.png";